import { render, staticRenderFns } from "./CustomerFeaturedProducts.vue?vue&type=template&id=b9013890&"
import script from "./CustomerFeaturedProducts.vue?vue&type=script&lang=ts&"
export * from "./CustomerFeaturedProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports